import { createSlice, createSelector } from "@reduxjs/toolkit";

export const aliasesSlice = createSlice({
  name: "aliases",
  initialState: {
    show: null,
    list: [],
    loadingShow: false,
    loadedShow: false,
    showError: null,
    creating: false,
    created: false,
    createError: null,
    updating: false,
    updated: false,
    updateError: null,
    removing: false,
    removed: false,
    removeError: null,
    idsList: [],
    dictionary: {},
    slugIndex: {},
    showId: null,
    filtersToIdsDictionary: {},
  },
  reducers: {
    list: (state, action) => {
      state.loadingList = true;
      state.loadedList = false;
      state.listError = null;
      state.list = [];
      //   let cachedList = [];
      //   var ids = state.filtersToIdsDictionary[JSON.stringify(newFilters)];
      //   if (ids && ids.length) {
      //     state.idsList = ids;
      //     ids.forEach((id) => {
      //       const entry = state.dictionary[id];
      //       if (entry) cachedList.push(entry);
      //     });
      //   }
      //   state.list = cachedList;

      // }
    },
    listSuccess: (state, action) => {
      const responseList = action.payload.data || [];
      const responseIds = action.payload.data.map((a) => a.id);

      state.loadingList = false;
      state.loadedList = true;

      state.list = responseList;
      state.idsList = responseIds;
      responseList.forEach((entry) => (state.dictionary[entry.id] = entry));
    },
    listFail: (state, action) => {
      state.loadingList = false;
      state.loadedList = false;
      state.listError = action.payload.mess;
    },
    show: (state, action) => {
      state.loadingShow = true;
      state.loadedShow = false;
      state.showError = null;
      state.show = state.dictionary[action.payload.id] || {};
      state.showId = action.payload.id || null;
    },
    resetCase: (state, action) => {
      // Reset Case means deleting the local data
      state.dictionary[action.payload.id] = {};
      state.showId = null;
      state.creating = false;
      state.updating = false;
    },
    showSuccess: (state, action) => {
      state.loadingShow = false;
      state.loadedShow = true;
      state.show = action.payload.data;
      state.showId = action.payload.data.id;
      state.dictionary[action.payload.data.id] = action.payload.data;
    },
    showFail: (state, action) => {
      state.loadingShow = false;
      state.loadedShow = false;
      state.listError = action.payload.mess;
    },
    update: (state, action) => {
      state.updating = true;
      state.updated = false;
      state.updateError = null;
    },
    updateSuccess: (state, action) => {
      state.updating = false;
      state.updated = true;
      state.show = action.payload.data;
      state.showId = action.payload.data.id;
      state.dictionary[action.payload.data.id] = action.payload.data;
    },
    updateFail: (state, action) => {
      state.updating = false;
      state.updated = false;
      state.updateError = action.payload.response.obj;
    },
    create: (state, action) => {
      state.creating = true;
      state.created = false;
      state.createError = null;
    },
    createSuccess: (state, action) => {
      state.creating = false;
      state.created = true;
      state.show = action.payload.data;
      state.showId = action.payload.data.id;
      state.dictionary[action.payload.data.id] = action.payload.data;
    },
    createFail: (state, action) => {
      state.creating = false;
      state.created = false;
      state.listError = action.payload.mess;
    },
    updateDictionary: (state, action) => {
      action.payload.forEach((static_page) => {
        state.dictionary[static_page.id] = static_page;
      });
    },
    addToDictionary: (state, action) => {
      state.dictionary[action.payload.id] = {
        ...state.dictionary[action.payload.id],
        ...action.payload,
      };
    },
  },
});

export const {
  list: listAliases,
  show: showCase,
  update: updateCase,
  create: createCase,
  resetCase,
  updateDictionary: updateAliasesDictionary,
  addToDictionary: addToAliasesDictionary,
} = aliasesSlice.actions;

export const actions = aliasesSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const aliasesList = (state) =>
  state.aliases.idsList.map((id) => state.aliases.dictionary[id]);

export const caseShowId = (state) => state.aliases.showId;

export const getCase = createSelector(
  (state) => state.aliases.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getCaseAttributes = createSelector(
  (state) => state.aliases.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getCaseRelationships = createSelector(
  (state) => state.aliases.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export default aliasesSlice.reducer;
